import React, { createContext, useState, useContext, useCallback } from 'react';

export const TourContext = createContext();

export const useTour = () => {
  const context = useContext(TourContext);
  if (!context) {
    return {
      runTour: false,
      setRunTour: () => {},
    };
  }
  return context;
};

export const TourProvider = ({ children }) => {
  const [runTour, setRunTour] = useState(false);

  const startTour = useCallback(() => setRunTour(true), []);
  const stopTour = useCallback(() => setRunTour(false), []);

  return (
    <TourContext.Provider value={{ runTour, setRunTour, startTour, stopTour }}>
      {children}
    </TourContext.Provider>
  );
};
